import React from "react";
import { getQuotationFor } from "../../../Components/Functions/word.fun";

const AIFSIReport = ({ allQData, data }) => {
  return (
    <div style={{ marginTop: "10px" }}>
      <p>
        Dear Sir / Madam,
        <br />
      </p>
      <p>
        I/We find immense pleasure to introduce to myself, I/We am{" "}
        {data?.clientDetails?.businessName || data?.clientDetails.clientName}.
        We are planning to enter into vertical hydroponic business where we see
        higher returns on investment can be managed with help of modern
        technology.
        <br />
        We are planning to construct
        <b> {allQData && getQuotationFor(allQData?.input_info)} project.</b>
        We will be taking help to construct this project from Kryzen Biotech
        Private Limited (KBPL). As per our discussions, please find the detailed
        project report below along with the project financials.
      </p>

      {/* <h3 class="table-heading" style="text-align: center">Site Inspection Report</h3>

<p style="text-align: center">
  <%= image_tag(wicked_pdf_asset_base64(si.score_image), style: "height: 200px") %>
</p> */}

      <h3>Executive Summary:</h3>

      <p>
        In the pursuit of sustainable and innovative agricultural practices, the
        integration of modern technologies has become paramount. Hydroponic
        farming, a method of cultivating plants without soil, stands at the
        forefront of this agricultural revolution. This project report unfolds
        the journey of establishing a state-of-the-art hydroponic farm, an
        endeavor aimed at revolutionizing traditional farming methods and
        ensuring a more efficient, resource-conscious, and high-yielding
        approach to agriculture.
      </p>

      <p>
        <u>Background:</u> Traditional soil-based agriculture faces numerous
        challenges, including land degradation, water scarcity, and
        unpredictable climatic conditions. Hydroponic farming addresses these
        challenges by providing a controlled environment where crops receive
        precisely calibrated nutrients, water, and light. This not only enhances
        crop yield but also reduces water consumption and minimizes the need for
        chemical inputs.
      </p>

      <p>
        <u>Rationale:</u> The decision to embark on this hydroponic farm setup
        arises from a commitment to sustainable and economically viable
        agriculture. By harnessing advanced hydroponic techniques, we aim to
        create an ecosystem that fosters optimal plant growth, minimizes
        environmental impact, and ensures the production of high-quality,
        nutrient-rich crops. This project aligns with the global movement
        towards precision agriculture, promoting a more resilient and productive
        food system for the future.
      </p>

      <p>
        <u>Idea:</u> After research of years and working experience on multiplae
        locations. We have decided to boil down to Hydroponic farm construction
        to fulfil our objectives. Hydroponics crop farming is a line of farming
        that is classified under horty culture; it is a technique of cultivating
        crops by making use of mineral nutrient solutions, in water, without the
        support of soil. As a matter of fact, crops that are basically
        cultivated on terrestrial soil can successfully be grown with their
        roots in the mineral solution only, or in a torpid medium, such as
        perlite or gravel. The company is a combination of cutting-edge,
        high-quality, efficient food technology and production. It is committed
        to the improvement of taste in vegetables and excellent quality and
        nutritional value.
      </p>
      <div
        className="html2pdf__page-break"
        style={{ pageBreakAfter: "always", display: "block", clear: "both" }}
      ></div>

      <h3>Objectives</h3>

      <p>The primary objectives of this hydroponic farm setup include:</p>

      <ol>
        <li>
          Maximize Yield and Productivity:
          <ul>
            <li>
              Increase crop yield per unit area by optimizing growing conditions
            </li>
            <li>
              Utilize vertical or horizontal growing systems to enhance space
              utilization.
            </li>
          </ul>
        </li>
        <li>
          Efficient Resource Utilization:
          <ul>
            <li>
              Minimize water usage through recirculating nutrient systems.{" "}
            </li>
            <li>
              Optimize the use of nutrients and eliminate wastage with precision
              dosing.
            </li>
          </ul>
        </li>
        <li>
          Sustainable Agriculture Practices:
          <ul>
            <li>
              Reduce dependency on soil and combat issues of soil degradation.
            </li>
            <li>
              Promote eco-friendly farming with minimal environmental impact
            </li>
          </ul>
        </li>
        <li>
          Consistent Crop Production:
          <ul>
            <li>
              Ensure year-round cultivation by providing controlled
              environmental conditions.
            </li>
            <li>
              Reduce dependency on external weather patterns and seasonal
              changes.
            </li>
          </ul>
        </li>

        <li>
          Improved Crop Quality:
          <ul>
            <li>
              Enhance the nutritional value, flavor, and appearance of produce.
            </li>
            <li>
              Ensure pesticide-free and disease-free crops for healthier
              consumption.
            </li>
          </ul>
        </li>
        <li>
          Economic Viability:
          <ul>
            <li>
              Achieve cost-efficiency through automation and optimized labor
              usage.
            </li>
            <li>
              Generate higher profitability by producing premium-quality crops
              that command better market prices.
            </li>
          </ul>
        </li>
        <li>
          Urban Farming and Space Optimization:
          <ul>
            <li>
              Provide solutions for farming in urban and peri-urban areas where
              arable land is scarce.
            </li>
            <li>
              Enable rooftop or indoor farming to reduce the carbon footprint.
            </li>
          </ul>
        </li>
        <li>
          Technology Integration:
          <ul>
            <li>
              Utilize IoT, AI, and data analytics for real-time monitoring and
              decision-making.
            </li>
            <li>
              Integrate advanced systems for climate control, pest management,
              and nutrient delivery.
            </li>
          </ul>
        </li>
        <li>
          Market Demand Fulfillment:
          <ul>
            <li>
              Cater to the increasing demand for organic, fresh, and
              locally-grown produce.
            </li>
            <li>
              Diversify crop selection to include niche or high-demand crops
              like herbs, microgreens, and exotic vegetables.
            </li>
          </ul>
        </li>
        <li>
          Educational and Research Opportunities:
          <ul>
            <li>
              Provide a platform for agricultural research, innovation, and
              training in hydroponic techniques.
            </li>
            <li>
              Serve as a demonstration site for educating farmers and potential
              investors about sustainable practices.
            </li>
          </ul>
        </li>
        <li>
          Scalability and Replicability:
          <ul>
            <li>
              Develop a scalable farming model suitable for small, medium, or
              large operations.
            </li>
            <li>
              Design modular systems that can be adapted to different
              geographies and climates.
            </li>
          </ul>
        </li>
        <li>
          Reduction in Logistics and Supply Chain Costs:
          <ul>
            <li>
              Grow crops closer to consumers to reduce transport costs and
              post-harvest losses.
            </li>
            <li>Promote local food systems and strengthen food security.</li>
          </ul>
        </li>
      </ol>

      <p>
        As we delve into the details of the project, this report will provide a
        comprehensive overview of the chosen hydroponic system, the selection of
        crops, the infrastructure setup, and the expected outcomes. It is our
        sincere belief that this hydroponic farm will not only serve as a
        blueprint for modern farming practices but will also contribute to the
        broader conversation on sustainable food production.
        <br />
        With innovation as our compass and sustainability as our guide, we
        invite you to explore the intricacies of this hydroponic farm setup and
        envision a future where agriculture meets the demands of a growing
        population while preserving the delicate balance of our planet's
        resources.
      </p>
      <div
        className="html2pdf__page-break"
        style={{ pageBreakAfter: "always", display: "block", clear: "both" }}
      ></div>
      <h3>Protected Cultivation in Polyhouse</h3>
      <h3>Why did we choose Polyhouse?</h3>

      <p>
        Polyhouse farming is a way of protected cultivation in agriculture.
        Polyethene plastic is used to cover the structure. It enables the
        cultivation of high-value crops(horticulture) in the structure. Some are
        naturally ventilated poly houses and some are under the total climate
        control system having motorised screens and ventilators.
      </p>
      <p>
        Protected cultivation under Polyhouse is gaining importance these days.
        It proves to be beneficial to the farmers since it enables Season
        cultivation of vegetables/fruits which enables the farmer to have a
        better price realisation. It extends the life cycle of the crops and
        provides a controlled environment for the crops.
      </p>
      <ol>
        <li>
          Controlled Environment for Optimal Growthul{" "}
          <ul>
            <li>
              Protects crops from adverse weather conditions like extreme heat,
              cold, heavy rain, and wind.
            </li>
            <li>
              {" "}
              Allows control over temperature, humidity, and light, ensuring
              ideal conditions for plant growth.
            </li>
          </ul>
        </li>
        <li>
          Higher Crop Yield{" "}
          <ul>
            <li>
              Enables multiple cropping cycles in a year, increasing
              productivity per unit area.
            </li>
            <li>Promotes faster growth rates due to optimized conditions.</li>
          </ul>
        </li>
        <li>
          Improved Quality of Produce{" "}
          <ul>
            <li>
              Enhances the uniformity, appearance, and nutritional value of
              crops.
            </li>
            <li>
              Reduces pest and disease damage, leading to healthier produce.
            </li>
          </ul>
        </li>
        <li>
          Efficient Water Use{" "}
          <ul>
            <li>
              Utilizes systems like drip irrigation, reducing water wastage.
            </li>
            <li>Conserves water compared to open-field farming.</li>
          </ul>
        </li>
        <li>
          Reduced Use of Agrochemicals{" "}
          <ul>
            <li>
              Minimizes the need for pesticides and fungicides by providing a
              barrier against pests and diseases.
            </li>
            <li>Promotes safer, chemical-free produce.</li>
          </ul>
        </li>
        <li>
          Off-Season Production{" "}
          <ul>
            <li>
              Allows cultivation of crops throughout the year, regardless of
              their natural growing season.
            </li>
            <li>
              Helps meet market demand for off-season produce, often fetching
              higher prices.
            </li>
          </ul>
        </li>
        <li>
          Space Optimization{" "}
          <ul>
            <li>
              Vertical farming and high-density planting can optimize limited
              land resources.
            </li>
            <li>Ideal for urban and peri-urban farming environments.</li>
          </ul>
        </li>
        <li>
          Reduced Crop Losses{" "}
          <ul>
            <li>
              Protects crops from environmental risks like hailstorms, frost,
              and floods.
            </li>{" "}
            <li>
              Provides a controlled environment to mitigate losses from pests
              and diseases.
            </li>
          </ul>
        </li>
        <li>
          Enhanced Resource Efficiency{" "}
          <ul>
            <li>
              Optimizes nutrient delivery using hydroponic or fertigation
              systems.
            </li>
            <li>
              Reduces labor costs through automation and precision agriculture
              techniques.
            </li>
          </ul>
        </li>
        <li>
          Scalability and Customization{" "}
          <ul>
            <li>Can be adapted to small-scale or large-scale operations.</li>{" "}
            <li>
              Customize buildings (e.g., polyhouses, net houses) to suit local
              climate and crop needs.
            </li>
          </ul>
        </li>
        <li>
          Economic Benefits{" "}
          <ul>
            <li>
              Increases profitability through higher yields and premium-quality
              produce.
            </li>
            <li>Reduces post-harvest losses by growing closer to markets.</li>
          </ul>
        </li>
        <li>
          Sustainable Farming{" "}
          <ul>
            <li>
              Promotes eco-friendly practices by reducing water, land, and
              chemical use.
            </li>{" "}
            <li>
              Supports the cultivation of crops in regions with unfavorable soil
              or climatic conditions.
            </li>
          </ul>
        </li>
      </ol>

      <div
        className="html2pdf__page-break"
        style={{ pageBreakAfter: "always", display: "block", clear: "both" }}
      ></div>
      <h3>Hydroponic growing technology</h3>
      <h3>Why did we choose Hydroponics?</h3>

      <p>
        Hydroponics uses less water than soil growing - in some cases up to 90%
        less water than traditional soil-based agriculture. You can plant 4
        times the amount of crops in the same space as soil farming. Grow all
        year long. Hydroponics allows for an optimally controlled environment
        and growth.
      </p>

      <ol>
        <li>
          Efficient Use of Water
          <ul>
            <li>
              Uses up to 90% less water compared to traditional farming due to
              recirculation systems.
            </li>
            <li>
              Reduces water wastage and is ideal for areas with limited water
              resources.
            </li>
          </ul>
        </li>
        <li>
          No Dependency on Soil
          <ul>
            <li>
              Eliminates the need for fertile soil, making it suitable for areas
              with poor or contaminated soil.
            </li>
            <li>
              Avoids soil-borne pests and diseases, reducing crop loss and
              pesticide use.
            </li>
          </ul>
        </li>
        <li>
          Space Optimization
          <ul>
            <li>
              Allows vertical farming, enabling efficient use of limited space.
            </li>
            <li>
              Ideal for urban and indoor farming, including rooftops and
              greenhouses.
            </li>
          </ul>
        </li>
        <li>
          Faster Growth and Higher Yield
          <ul>
            <li>
              Provides plants with direct access to nutrients, leading to faster
              growth cycles.
            </li>
            <li>
              Increases productivity per unit area compared to soil-based
              farming.
            </li>
          </ul>
        </li>
        <li>
          Consistent and Controlled Environment{" "}
          <ul>
            <li>
              Ensures year-round cultivation by controlling temperature, light,
              humidity, and nutrients.
            </li>
            <li>
              Reduces risks from unpredictable weather and climate changes.
            </li>
          </ul>
        </li>
        <li>
          Improved Crop Quality{" "}
          <ul>
            <li>
              Produces uniform, healthier, and pesticide-free crops with better
              taste and nutritional value.
            </li>
            <li>
              Reduces chemical contamination, making produce safer for
              consumption.
            </li>
          </ul>
        </li>
        <li>
          Reduced Use of Agrochemicals{" "}
          <ul>
            <li>
              Minimizes the need for fertilizers and pesticides as the system
              delivers nutrients precisely.
            </li>
            <li>Reduces environmental pollution and lowers farming costs.</li>
          </ul>
        </li>
        <li>
          Less Labor Intensive
          <ul>
            <li>
              Automation and controlled systems reduce manual labor requirements
              for tasks like watering and weeding.
            </li>
            <li> Simplifies monitoring and management of crops.</li>
          </ul>
        </li>
        <li>
          Environmental Sustainability{" "}
          <ul>
            <li>- Reduces water and land usage, making it eco-friendly.</li>
            <li>Prevents soil erosion and land degradation.</li>
          </ul>
        </li>
        <li>
          Off-Season Crop Production{" "}
          <ul>
            <li>
              Allows cultivation of crops throughout the year, irrespective of
              seasons.
            </li>
            <li>
              Meets market demand for off-season produce, often commanding
              higher prices.
            </li>
          </ul>
        </li>
        <li>
          Scalability and Customization{" "}
          <ul>
            <li>
              Systems can be tailored for small-scale home setups or large
              commercial farms.
            </li>
            <li>
              Suitable for diverse crops, from leafy greens to fruits and
              flowers.
            </li>
          </ul>
        </li>
        <li>
          {" "}
          Reduced Transportation Costs{" "}
          <ul>
            <li>
              Facilitates local and urban farming, reducing transportation needs
              and carbon emissions.
            </li>
            <li>Ensures fresher produce with longer shelf life.</li>
          </ul>
        </li>
        <li>
          Research and Innovation Opportunities{" "}
          <ul>
            <li>
              Offers a platform for studying plant growth under controlled
              conditions.
            </li>
            <li>
              Encourages the adoption of modern technologies like IoT, AI, and
              automation.
            </li>
          </ul>
        </li>
      </ol>
      <div
        className="html2pdf__page-break"
        style={{ pageBreakAfter: "always", display: "block", clear: "both" }}
      ></div>
      {/* <h3>Keys to our success</h3>

      <ol>
        <li>
          Extensive Knowledge and Expertise
          <ul>
            <li>
              We bring a deep understanding of crops, technologies, and systems
              in controlled-environment agriculture.
            </li>
            <li>
              With a foundation in both theory and practice, we ensure every
              project is built on sound principles.
            </li>
          </ul>
        </li>
        <li>
          Strategic Site Selection and Robust Infrastructure
          <ul>
            <li>
              Our ability to identify optimal locations and design
              state-of-the-art protected structures ensures ideal growing
              conditions for any crop.
            </li>
            <li>
              From greenhouses to advanced hydroponic systems, we use top-tier
              infrastructure to guarantee efficiency and reliability.
            </li>
          </ul>
        </li>
        <li>
          Advanced Climate Control and Monitoring
          <ul>
            <li>
              We employ cutting-edge tools to monitor and manage temperature,
              humidity, and light.
            </li>
            <li>
              By integrating automation and sensors, we provide plants with the
              perfect environment for maximum growth and quality.
            </li>
          </ul>
        </li>
        <li>
          Commitment to Resource Efficiency
          <ul>
            <li>
              Our systems use water and nutrients efficiently, reducing waste
              and costs while ensuring sustainable operations.
            </li>
            <li>
              With technologies like nutrient recirculation and precise
              fertigation, we consistently deliver results with minimal resource
              input.
            </li>
          </ul>
        </li>
        <li>
          Tailored Crop Selection and Market Alignment
          <ul>
            <li>
              We understand market trends and customer needs, enabling us to
              select high-value crops with year-round demand.
            </li>
            <li>
              Strategic planning ensures continuous production and
              profitability.
            </li>
          </ul>
        </li>
        <li>
          Proactive Pest and Disease Management
          <ul>
            <li>
              Our integrated pest management (IPM) practices and strict hygiene
              protocols minimize risks, ensuring healthier crops and reduced
              dependency on chemicals.
            </li>
          </ul>
        </li>
        <li>
          Investment in Quality Inputs and Equipment
          <ul>
            <li>
              From premium seeds and growing media to advanced equipment, we
              focus on quality to deliver superior outcomes.
            </li>
            <li>
              Our durable systems and tools enhance operational efficiency and
              reliability.
            </li>
          </ul>
        </li>
        <li>
          Strong Market Linkages and Value Addition
          <ul>
            <li>
              With established connections to buyers and the ability to create
              value-added products, we ensure our produce reaches the right
              markets at premium prices.
            </li>
          </ul>
        </li>
        <li>
          Scalable and Flexible Solutions
          <ul>
            <li>
              We design systems that can scale based on performance and adapt to
              market and environmental changes.
            </li>
            <li>
              This flexibility allows us to respond swiftly to evolving needs.
            </li>
          </ul>
        </li>
        <li>
          Integration of Modern Technology
          <ul>
            <li>
              Our use of IoT, AI, and automation optimizes every aspect of
              cultivation, from monitoring to resource allocation.
            </li>
            <li>
              By leveraging technology, we stay ahead of the curve and deliver
              superior efficiency.
            </li>
          </ul>
        </li>
        <li>
          Sound Financial Planning and Cost Control
          <ul>
            <li>
              We ensure each project is financially viable, with clear ROI
              calculations and optimized cost structures.
            </li>
            <li>
              By leveraging subsidies and grants where possible, we maximize
              profitability for stakeholders.
            </li>
          </ul>
        </li>
        <li>
          Skilled Team and Continuous Training
          <ul>
            <li>
              Our team comprises highly trained professionals who excel in every
              aspect of protected cultivation and hydroponics.
            </li>
            <li>
              Ongoing training ensures we stay updated on the latest practices
              and technologies.
            </li>
          </ul>
        </li>
        <li>
          Focus on Compliance and Certification
          <ul>
            <li>
              We adhere to agricultural regulations and obtain certifications
              like organic or GAP to enhance trust and market value, ensuring
              our operations meet the highest standards.
            </li>
          </ul>
        </li>
        <li>
          Commitment to Innovation
          <ul>
            <li>
              By continuously experimenting with new crops and techniques, we
              stay at the forefront of advancements in the industry, delivering
              innovative solutions that drive success.
            </li>
          </ul>
        </li>
        <li>
          Customer-Centric Approach and Branding
          <ul>
            <li>
              We emphasize quality, freshness, and sustainability in everything
              we do.
            </li>
            <li>
              Through strong branding and direct customer engagement, we build
              lasting relationships that support long-term growth.
            </li>
          </ul>
        </li>
      </ol> */}

      {/* <div
        className="html2pdf__page-break"
        style={{ pageBreakAfter: "always", display: "block", clear: "both" }}
      ></div> */}
    </div>
  );
};

export default AIFSIReport;
